/* Breakpoint Tees — FAQ accordion
   Accessible, progressive-enhancement accordion.
   Markup works without JS (default-open items render open via CSS);
   this script adds click/keyboard toggling, aria state and optional
   single-open behaviour. Smooth open/close is handled purely in CSS
   (grid-template-rows 0fr -> 1fr) so there is no layout jump. */
(function () {
  'use strict';

  function initSection(section) {
    var single = section.getAttribute('data-single-open') === 'true';
    var items = Array.prototype.slice.call(section.querySelectorAll('.faqx__item'));

    function setOpen(item, open) {
      item.classList.toggle('open', open);
      var btn = item.querySelector('.faqx__btn');
      if (btn) { btn.setAttribute('aria-expanded', open ? 'true' : 'false'); }
    }

    items.forEach(function (item) {
      var btn = item.querySelector('.faqx__btn');
      if (!btn) { return; }
      btn.addEventListener('click', function () {
        var willOpen = !item.classList.contains('open');
        if (single && willOpen) {
          items.forEach(function (other) {
            if (other !== item) { setOpen(other, false); }
          });
        }
        setOpen(item, willOpen);
      });
    });
  }

  function init() {
    document.querySelectorAll('.faqx').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init when a section is added/updated in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.faqx');
    if (section) { initSection(section); }
  });
})();
